import React from 'react';

const SearchBox = ({ grab_input }) => {
	return (
		<div className='searchbox-section'>
			<input type='search' placeholder='Pokémon Search' onChange={grab_input} />
		</div>
	);
}

export default SearchBox;


// WEBPACK FOOTER //
// ./src/components/SearchBox.js